import { render, staticRenderFns } from "./TruckingService.vue?vue&type=template&id=3e5049a4&"
import script from "./TruckingService.vue?vue&type=script&lang=js&"
export * from "./TruckingService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports